import { AxiosResponse } from 'axios';

import { TAddProductToSchedulerResponse } from '../interfaces/import-product-scheduler-api';
import { ApiService } from './api.service';

export interface AddProductToSchedulerV2Payload {
  asins: string[];
  region: string;
  tag?: string;
  notify?: boolean;
}

class ImportProductSchedulerApi extends ApiService {
  addProductToScheduler(data: { asins: string[] }): Promise<AxiosResponse<TAddProductToSchedulerResponse>> {
    return this.post('/ext/scrapping/schedule', data);
  }

  addProductToSchedulerV2(data: AddProductToSchedulerV2Payload): Promise<AxiosResponse<{ message: string }>> {
    return this.post('/ext/import/asins/v2', data);
  }

  addWalmartProducts(data: { w_items_id: string[] }): Promise<AxiosResponse<{ message: string }>> {
    return this.post('/ext/import/walmart-products', data);
  }
}

let _client: ImportProductSchedulerApi;

export function getImportProductSchedulerApi(): ImportProductSchedulerApi {
  if (!_client) {
    _client = new ImportProductSchedulerApi(process.env.REACT_APP_API_HOST);
  }

  return _client;
}
